import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import useLocalStorage from "../../Hooks/useLocalStorage";

import axios from "axios";

export default function FormateurSatisfaction() {
	const [rating, setRating] = useState(0);
	const [rating2, setRating2] = useState(0);

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");
	const [sent, setSent] = useLocalStorage("completedFormateur", false);
	const [comment, setComment] = useState("");
	const [suggestion, setSuggestion] = useState("");

	var tooltipArr = [
		"Pas du tout",
		"Insuffisamment",
		"Moyennement",
		"En partie",
		"Totalement",
	];

	const sendForm = async e => {
		e.preventDefault();

		var avis1;
		var avis2;

		if (rating === 20) {
			avis1 = "Pas du tout";
		}

		if (rating === 40) {
			avis1 = "Insuffisamment";
		}

		if (rating === 60) {
			avis1 = "Moyennement";
		}

		if (rating === 80) {
			avis1 = "En partie";
		}

		if (rating === 100) {
			avis1 = "Totalement";
		}

		if (rating2 === 20) {
			avis2 = "Pas du tout";
		}

		if (rating2 === 40) {
			avis2 = "Insuffisamment";
		}

		if (rating2 === 60) {
			avis2 = "Moyennement";
		}

		if (rating2 === 80) {
			avis2 = "En partie";
		}

		if (rating2 === 100) {
			avis2 = "Totalement";
		}

		try {
			axios.post("https://global-academie.herokuapp.com/avis/formateur", {
				userID,
				userName,
				materiel: avis1,
				coordination: avis2,
				comment,
				suggestion,
			});
			setSent(true);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="flex min-h-screen w-full flex-col items-center justify-center">
			<form
				onSubmit={sendForm}
				className="my-16 flex w-1/2 flex-col items-center justify-center space-y-7"
			>
				<h2 className="flex w-full items-center justify-between text-3xl font-bold text-indigo-500">
					Questionnaire satisfaction formateurs
				</h2>
				<hr className="my-4 h-[3px] w-[100px] self-start border-none bg-indigo-200" />
				<div
					className={
						sent
							? "visible-check flex h-[250px] flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
							: "flex h-[0px] flex-col items-center justify-center overflow-hidden opacity-0 transition-all duration-300 ease-in-out"
					}
				>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Les conditions matérielles étaient adaptées?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating(rate)}
								ratingValue={rating}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							La coordination avec l'organisme s'est bien passée?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating2(rate)}
								ratingValue={rating2}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="commentaires"
						>
							Commentaires libres sur la formation
						</label>
						<textarea
							value={comment}
							onChange={e => setComment(e.target.value)}
							name="commentaires"
							id="commentaires"
							placeholder="Commentaires"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="Suggestion"
						>
							Suggestions d'amélioration
						</label>
						<textarea
							value={suggestion}
							onChange={e => setSuggestion(e.target.value)}
							name="Suggestion"
							id="Suggestion"
							placeholder="Suggestions"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<button
						type="submit"
						className="w-full rounded-md border-2 border-transparent bg-indigo-500 p-3 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
					>
						Envoyer
					</button>
				</div>
				<div
					className={
						sent
							? "visible-check flex h-[250px] flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
							: "flex h-[0px] flex-col items-center justify-center overflow-hidden opacity-0 transition-all duration-300 ease-in-out"
					}
				>
					<svg
						className="checkmark"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 52 52"
					>
						<circle
							className="checkmark__circle"
							cx="26"
							cy="26"
							r="25"
							fill="none"
						/>
						<path
							className="checkmark__check"
							fill="none"
							d="M14.1 27.2l7.1 7.2 16.7-16.8"
						/>
					</svg>
					<h4 className="my-7 text-2xl font-medium">
						Merci pour vos réponses!
					</h4>
				</div>
			</form>
		</div>
	);
}
